import {useCallback} from 'react';

import {useLatest} from './useLatest';

export function useEvent<AnyFn extends (...args: any[]) => any>(fn: AnyFn): AnyFn {
    const latest = useLatest(fn);

    // `latest` is a stable ref, so disabling the exhaustive-deps rule is safe here and avoids
    // a tiny bit of overhead.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return useCallback((...args: any[]) => latest.current(...args), []) as AnyFn;
}
